import { render } from "./PointHome.vue?vue&type=template&id=5e0e1299&scoped=true"
import script from "./PointHome.vue?vue&type=script&lang=js"
export * from "./PointHome.vue?vue&type=script&lang=js"

import "./PointHome.vue?vue&type=style&index=0&id=5e0e1299&lang=less&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e0e1299"]])

export default __exports__